<app-hero-imagenes/>
<app-info-imagenes/>
